export default __webpack_public_path__ + "static/7-784b35dc11616664348d8715f7dbaa64.jpg";